import type { ReactNode } from 'react';

export const symbol_battery_android_share: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M130-240q-37.5 0-63.75-26.25T40-330v-300q0-37.5 26.25-63.75T130-720h551q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H130q-12.75 0-21.37 8.62Q100-642.75 100-630v300q0 12.75 8.63 21.37Q117.25-300 130-300h310q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H130Zm-30-60v-360 360Zm481.5-38.63q8.5-8.62 8.5-21.37v-90h201l-52 52q-9 9-9 21t9.05 21q9.06 9 21.5 9 12.45 0 21.45-9l103-103q9-9 9-21t-9-21L781-605q-9-9-21-9t-21 9q-9 9-8.5 21t8.5 21l52 53H590q-24 0-42 18t-18 42v90q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63Z"
		/>
	</svg>
);
